import React, { FC, memo } from 'react';
import { Icon, Tooltip } from 'udesk-ui';
import styled from 'styled-components';

const Wrapper = styled.div`
    background: rgba(25, 110, 255, 0.03);
    border-radius: 2px;
    width: calc(25% - 16px);
    margin: 4px 8px;
    height: 122px;
    padding: 16px;
    position: relative;
    .numerical-card-tooltip {
        position: absolute;
        top: 16px;
        right: 16px;
    }
    .numerical-card-main {
        display: flex;
        .numerical-card-main-icon {
            width: 48px;
            height: 48px;
            background: #1a6eff;
            border-radius: 50%;
            margin-right: 20px;
        }
        .numerical-card-main-count {
            .title {
                font-size: 14px;
                line-height: 22px;
                color: rgba(0, 0, 0, 0.45);
                text-transform: capitalize;
            }
            .count {
                font-weight: 500;
                font-size: 24px;
                line-height: 32px;
                color: rgba(0, 0, 0, 0.85);
            }
        }
    }
    .numerical-card-desc {
        font-size: 14px;
        line-height: 22px;
        color: #1a6eff;
        margin-left: 68px;
        margin-top: 8px;
        text-transform: capitalize;
    }
`;

interface TemplateProps {
    tip?: React.ReactNode;
    subTip?: React.ReactNode;
    icon?: string;
    percentName?: string;
    name?: string;
    data?: string;
    percent?: string;
}

const Template: FC<TemplateProps> = memo((props) => {
    const tip = props.subTip ? (
        <div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{props.tip}</div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{props.subTip}</div>
        </div>
    ) : props.tip ? (
        <div style={{ whiteSpace: 'pre-wrap' }}>{props.tip}</div>
    ) : null;

    return (
        <Wrapper>
            {tip ? (
                <div className="numerical-card-tooltip">
                    <Tooltip title={tip} placement="topRight">
                        <Icon
                            antdIcon={true}
                            type="InfoCircleOutlined"
                            style={{ color: 'rgba(0, 0, 0, 0.25)' }}
                        />
                    </Tooltip>
                </div>
            ) : null}

            <div className="numerical-card-main">
                <div className="numerical-card-main-icon">
                    <Icon type={props.icon!} style={{ fontSize: '48px' }} />
                </div>
                <div className="numerical-card-main-count">
                    <div className="title">{props.name}</div>
                    <div className="count">{props.data || '-'}</div>
                </div>
            </div>

            {props.percentName && (
                <div className="numerical-card-desc">
                    {`${props.percentName}: ${props.percent || '-'}`}
                </div>
            )}
        </Wrapper>
    );
});

export default Template;
